import axios from "../components/shared/axios";

const baseURL = `${process.env.REACT_APP_BACKEND_URL}`;

export const getShortUrls = async (pageNo, pageSize, param) => {
  try {
    let params = {};
    if (param) params = { pageNo, pageSize, ...param };
    else params = { pageNo, pageSize };
    return await axios.get(`${baseURL}/short-url`, { params });
  } catch (error) {
    return { error: error.message };
  }
};

export const addShortUrl = async (params) => {
  try {
    return await axios.post(`${baseURL}/short-url`, params);
  } catch (error) {
    return { error: error.message };
  }
};

export const updateShortUrl = async (id, params) => {
  try {
    return await axios.put(`${baseURL}/short-url/${id}`, params);
  } catch (error) {
    return { error: error.message };
  }
};

export const deleteShortUrl = async (id, params) => {
  try {
    return await axios.delete(`${baseURL}/short-url/${id}`, params);
  } catch (error) {
    return { error: error.message };
  }
};